import { render } from "./boxFileTree.vue?vue&type=template&id=badff0e2&scoped=true"
import script from "./boxFileTree.vue?vue&type=script&lang=js"
export * from "./boxFileTree.vue?vue&type=script&lang=js"

import "./boxFileTree.vue?vue&type=style&index=0&id=badff0e2&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-badff0e2"]])

export default __exports__